// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as StudioRouteImport } from './routes/studio'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as ServiceAreasRouteImport } from './routes/service-areas'
import { Route as ResidentialRouteImport } from './routes/residential'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PortfolioRouteImport } from './routes/portfolio'
import { Route as EstimateRouteImport } from './routes/estimate'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CommercialRouteImport } from './routes/commercial'
import { Route as ColorsRouteImport } from './routes/colors'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PortalIndexRouteImport } from './routes/portal.index'
import { Route as GalleryIndexRouteImport } from './routes/gallery.index'
import { Route as ShareTokenRouteImport } from './routes/share.$token'
import { Route as ReviewTokenRouteImport } from './routes/review.$token'
import { Route as ProposalTokenRouteImport } from './routes/proposal.$token'
import { Route as GalleryProjectIdRouteImport } from './routes/gallery.$projectId'
import { Route as AuthenticatedSetupAdminRouteImport } from './routes/_authenticated/setup-admin'
import { Route as AuthenticatedPortalRouteImport } from './routes/_authenticated/portal'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as PortalClaimTokenRouteImport } from './routes/portal.claim.$token'
import { Route as DotlovableOauthConsentRouteImport } from './routes/[.]lovable.oauth.consent'
import { Route as ReviewTokenThanksRouteImport } from './routes/review.$token.thanks'
import { Route as AuthenticatedPortalWarrantyRouteImport } from './routes/_authenticated/portal.warranty'
import { Route as AuthenticatedPortalScheduleRouteImport } from './routes/_authenticated/portal.schedule'
import { Route as AuthenticatedPortalProposalRouteImport } from './routes/_authenticated/portal.proposal'
import { Route as AuthenticatedPortalProjectRouteImport } from './routes/_authenticated/portal.project'
import { Route as AuthenticatedPortalProfileRouteImport } from './routes/_authenticated/portal.profile'
import { Route as AuthenticatedPortalPaymentsRouteImport } from './routes/_authenticated/portal.payments'
import { Route as AuthenticatedPortalNotificationsRouteImport } from './routes/_authenticated/portal.notifications'
import { Route as AuthenticatedPortalNotificationSettingsRouteImport } from './routes/_authenticated/portal.notification-settings'
import { Route as AuthenticatedPortalMessagesRouteImport } from './routes/_authenticated/portal.messages'
import { Route as AuthenticatedPortalInvoicesRouteImport } from './routes/_authenticated/portal.invoices'
import { Route as AuthenticatedPortalGalleryRouteImport } from './routes/_authenticated/portal.gallery'
import { Route as AuthenticatedPortalDocumentsRouteImport } from './routes/_authenticated/portal.documents'
import { Route as AuthenticatedPortalDashboardRouteImport } from './routes/_authenticated/portal.dashboard'
import { Route as AuthenticatedPortalColorsRouteImport } from './routes/_authenticated/portal.colors'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin.index'
import { Route as AuthenticatedAdminUsersRouteImport } from './routes/_authenticated/admin.users'
import { Route as AuthenticatedAdminTasksRouteImport } from './routes/_authenticated/admin.tasks'
import { Route as AuthenticatedAdminSettingsRouteImport } from './routes/_authenticated/admin.settings'
import { Route as AuthenticatedAdminReviewsRouteImport } from './routes/_authenticated/admin.reviews'
import { Route as AuthenticatedAdminPricingRouteImport } from './routes/_authenticated/admin.pricing'
import { Route as AuthenticatedAdminPipelineRouteImport } from './routes/_authenticated/admin.pipeline'
import { Route as AuthenticatedAdminOverviewRouteImport } from './routes/_authenticated/admin.overview'
import { Route as AuthenticatedAdminNotificationSettingsRouteImport } from './routes/_authenticated/admin.notification-settings'
import { Route as AuthenticatedAdminMessagesRouteImport } from './routes/_authenticated/admin.messages'
import { Route as AuthenticatedAdminLeadsRouteImport } from './routes/_authenticated/admin.leads'
import { Route as AuthenticatedAdminHelpRouteImport } from './routes/_authenticated/admin.help'
import { Route as AuthenticatedAdminHeatMapsRouteImport } from './routes/_authenticated/admin.heat-maps'
import { Route as AuthenticatedAdminHealthRouteImport } from './routes/_authenticated/admin.health'
import { Route as AuthenticatedAdminFunnelsRouteImport } from './routes/_authenticated/admin.funnels'
import { Route as AuthenticatedAdminEstimatesRouteImport } from './routes/_authenticated/admin.estimates'
import { Route as AuthenticatedAdminCalendarRouteImport } from './routes/_authenticated/admin.calendar'
import { Route as AuthenticatedAdminAuditRouteImport } from './routes/_authenticated/admin.audit'
import { Route as AuthenticatedAdminAnalyticsRouteImport } from './routes/_authenticated/admin.analytics'
import { Route as AuthenticatedAdminAiUsageRouteImport } from './routes/_authenticated/admin.ai-usage'
import { Route as AuthenticatedAdminActivityRouteImport } from './routes/_authenticated/admin.activity'
import { Route as AuthenticatedAdminAccountingRouteImport } from './routes/_authenticated/admin.accounting'
import { Route as AuthenticatedPortalInvoicesIdRouteImport } from './routes/_authenticated/portal.invoices.$id'
import { Route as AuthenticatedAdminProposalsIndexRouteImport } from './routes/_authenticated/admin.proposals.index'
import { Route as AuthenticatedAdminCustomersIndexRouteImport } from './routes/_authenticated/admin.customers.index'
import { Route as AuthenticatedAdminContactsIndexRouteImport } from './routes/_authenticated/admin.contacts.index'
import { Route as AuthenticatedAdminProposalsIdRouteImport } from './routes/_authenticated/admin.proposals.$id'
import { Route as AuthenticatedAdminCustomersProjectIdRouteImport } from './routes/_authenticated/admin.customers.$projectId'
import { Route as AuthenticatedAdminContactsIdRouteImport } from './routes/_authenticated/admin.contacts.$id'
import { Route as AuthenticatedAdminAccountingSettingsRouteImport } from './routes/_authenticated/admin.accounting.settings'
import { Route as AuthenticatedAdminAccountingReportsRouteImport } from './routes/_authenticated/admin.accounting.reports'
import { Route as AuthenticatedAdminAccountingReceivablesRouteImport } from './routes/_authenticated/admin.accounting.receivables'
import { Route as AuthenticatedAdminAccountingProfitabilityRouteImport } from './routes/_authenticated/admin.accounting.profitability'
import { Route as AuthenticatedAdminAccountingPaymentsRouteImport } from './routes/_authenticated/admin.accounting.payments'
import { Route as AuthenticatedAdminAccountingInvoicesRouteImport } from './routes/_authenticated/admin.accounting.invoices'
import { Route as AuthenticatedAdminAccountingExpensesRouteImport } from './routes/_authenticated/admin.accounting.expenses'
import { Route as AuthenticatedAdminAccountingDepositsRouteImport } from './routes/_authenticated/admin.accounting.deposits'
import { Route as AuthenticatedAdminProposalsIdPreviewRouteImport } from './routes/_authenticated/admin.proposals.$id.preview'
import { Route as AuthenticatedAdminEstimatesIdProposalRouteImport } from './routes/_authenticated/admin.estimates.$id.proposal'
import { Route as AuthenticatedAdminAccountingInvoicesIndexRouteImport } from './routes/_authenticated/admin.accounting.invoices.index'
import { Route as AuthenticatedAdminAccountingInvoicesNewRouteImport } from './routes/_authenticated/admin.accounting.invoices.new'
import { Route as AuthenticatedAdminAccountingInvoicesIdRouteImport } from './routes/_authenticated/admin.accounting.invoices.$id'
import { Route as AuthenticatedAdminAccountingInvoicesIdPrintRouteImport } from './routes/_authenticated/admin.accounting.invoices.$id.print'

const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const StudioRoute = StudioRouteImport.update({
            id: '/studio',path: '/studio',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const ServiceAreasRoute = ServiceAreasRouteImport.update({
            id: '/service-areas',path: '/service-areas',getParentRoute: () => rootRouteImport
          })
const ResidentialRoute = ResidentialRouteImport.update({
            id: '/residential',path: '/residential',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PortfolioRoute = PortfolioRouteImport.update({
            id: '/portfolio',path: '/portfolio',getParentRoute: () => rootRouteImport
          })
const EstimateRoute = EstimateRouteImport.update({
            id: '/estimate',path: '/estimate',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CommercialRoute = CommercialRouteImport.update({
            id: '/commercial',path: '/commercial',getParentRoute: () => rootRouteImport
          })
const ColorsRoute = ColorsRouteImport.update({
            id: '/colors',path: '/colors',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const PortalIndexRoute = PortalIndexRouteImport.update({
            id: '/portal/',path: '/portal/',getParentRoute: () => rootRouteImport
          })
const GalleryIndexRoute = GalleryIndexRouteImport.update({
            id: '/gallery/',path: '/gallery/',getParentRoute: () => rootRouteImport
          })
const ShareTokenRoute = ShareTokenRouteImport.update({
            id: '/share/$token',path: '/share/$token',getParentRoute: () => rootRouteImport
          })
const ReviewTokenRoute = ReviewTokenRouteImport.update({
            id: '/review/$token',path: '/review/$token',getParentRoute: () => rootRouteImport
          })
const ProposalTokenRoute = ProposalTokenRouteImport.update({
            id: '/proposal/$token',path: '/proposal/$token',getParentRoute: () => rootRouteImport
          })
const GalleryProjectIdRoute = GalleryProjectIdRouteImport.update({
            id: '/gallery/$projectId',path: '/gallery/$projectId',getParentRoute: () => rootRouteImport
          })
const AuthenticatedSetupAdminRoute = AuthenticatedSetupAdminRouteImport.update({
            id: '/setup-admin',path: '/setup-admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPortalRoute = AuthenticatedPortalRouteImport.update({
            id: '/portal',path: '/portal',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const PortalClaimTokenRoute = PortalClaimTokenRouteImport.update({
            id: '/portal/claim/$token',path: '/portal/claim/$token',getParentRoute: () => rootRouteImport
          })
const DotlovableOauthConsentRoute = DotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => rootRouteImport
          })
const ReviewTokenThanksRoute = ReviewTokenThanksRouteImport.update({
            id: '/thanks',path: '/thanks',getParentRoute: () => ReviewTokenRoute
          })
const AuthenticatedPortalWarrantyRoute = AuthenticatedPortalWarrantyRouteImport.update({
            id: '/warranty',path: '/warranty',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalScheduleRoute = AuthenticatedPortalScheduleRouteImport.update({
            id: '/schedule',path: '/schedule',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalProposalRoute = AuthenticatedPortalProposalRouteImport.update({
            id: '/proposal',path: '/proposal',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalProjectRoute = AuthenticatedPortalProjectRouteImport.update({
            id: '/project',path: '/project',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalProfileRoute = AuthenticatedPortalProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalPaymentsRoute = AuthenticatedPortalPaymentsRouteImport.update({
            id: '/payments',path: '/payments',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalNotificationsRoute = AuthenticatedPortalNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalNotificationSettingsRoute = AuthenticatedPortalNotificationSettingsRouteImport.update({
            id: '/notification-settings',path: '/notification-settings',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalMessagesRoute = AuthenticatedPortalMessagesRouteImport.update({
            id: '/messages',path: '/messages',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalInvoicesRoute = AuthenticatedPortalInvoicesRouteImport.update({
            id: '/invoices',path: '/invoices',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalGalleryRoute = AuthenticatedPortalGalleryRouteImport.update({
            id: '/gallery',path: '/gallery',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalDocumentsRoute = AuthenticatedPortalDocumentsRouteImport.update({
            id: '/documents',path: '/documents',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalDashboardRoute = AuthenticatedPortalDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalColorsRoute = AuthenticatedPortalColorsRouteImport.update({
            id: '/colors',path: '/colors',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminUsersRoute = AuthenticatedAdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminTasksRoute = AuthenticatedAdminTasksRouteImport.update({
            id: '/tasks',path: '/tasks',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSettingsRoute = AuthenticatedAdminSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminReviewsRoute = AuthenticatedAdminReviewsRouteImport.update({
            id: '/reviews',path: '/reviews',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminPricingRoute = AuthenticatedAdminPricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminPipelineRoute = AuthenticatedAdminPipelineRouteImport.update({
            id: '/pipeline',path: '/pipeline',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminOverviewRoute = AuthenticatedAdminOverviewRouteImport.update({
            id: '/overview',path: '/overview',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminNotificationSettingsRoute = AuthenticatedAdminNotificationSettingsRouteImport.update({
            id: '/notification-settings',path: '/notification-settings',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminMessagesRoute = AuthenticatedAdminMessagesRouteImport.update({
            id: '/messages',path: '/messages',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminLeadsRoute = AuthenticatedAdminLeadsRouteImport.update({
            id: '/leads',path: '/leads',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminHelpRoute = AuthenticatedAdminHelpRouteImport.update({
            id: '/help',path: '/help',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminHeatMapsRoute = AuthenticatedAdminHeatMapsRouteImport.update({
            id: '/heat-maps',path: '/heat-maps',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminHealthRoute = AuthenticatedAdminHealthRouteImport.update({
            id: '/health',path: '/health',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminFunnelsRoute = AuthenticatedAdminFunnelsRouteImport.update({
            id: '/funnels',path: '/funnels',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminEstimatesRoute = AuthenticatedAdminEstimatesRouteImport.update({
            id: '/estimates',path: '/estimates',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminCalendarRoute = AuthenticatedAdminCalendarRouteImport.update({
            id: '/calendar',path: '/calendar',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAuditRoute = AuthenticatedAdminAuditRouteImport.update({
            id: '/audit',path: '/audit',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAnalyticsRoute = AuthenticatedAdminAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAiUsageRoute = AuthenticatedAdminAiUsageRouteImport.update({
            id: '/ai-usage',path: '/ai-usage',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminActivityRoute = AuthenticatedAdminActivityRouteImport.update({
            id: '/activity',path: '/activity',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAccountingRoute = AuthenticatedAdminAccountingRouteImport.update({
            id: '/accounting',path: '/accounting',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedPortalInvoicesIdRoute = AuthenticatedPortalInvoicesIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AuthenticatedPortalInvoicesRoute
          })
const AuthenticatedAdminProposalsIndexRoute = AuthenticatedAdminProposalsIndexRouteImport.update({
            id: '/proposals/',path: '/proposals/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminCustomersIndexRoute = AuthenticatedAdminCustomersIndexRouteImport.update({
            id: '/customers/',path: '/customers/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminContactsIndexRoute = AuthenticatedAdminContactsIndexRouteImport.update({
            id: '/contacts/',path: '/contacts/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminProposalsIdRoute = AuthenticatedAdminProposalsIdRouteImport.update({
            id: '/proposals/$id',path: '/proposals/$id',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminCustomersProjectIdRoute = AuthenticatedAdminCustomersProjectIdRouteImport.update({
            id: '/customers/$projectId',path: '/customers/$projectId',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminContactsIdRoute = AuthenticatedAdminContactsIdRouteImport.update({
            id: '/contacts/$id',path: '/contacts/$id',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAccountingSettingsRoute = AuthenticatedAdminAccountingSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedAdminAccountingRoute
          })
const AuthenticatedAdminAccountingReportsRoute = AuthenticatedAdminAccountingReportsRouteImport.update({
            id: '/reports',path: '/reports',getParentRoute: () => AuthenticatedAdminAccountingRoute
          })
const AuthenticatedAdminAccountingReceivablesRoute = AuthenticatedAdminAccountingReceivablesRouteImport.update({
            id: '/receivables',path: '/receivables',getParentRoute: () => AuthenticatedAdminAccountingRoute
          })
const AuthenticatedAdminAccountingProfitabilityRoute = AuthenticatedAdminAccountingProfitabilityRouteImport.update({
            id: '/profitability',path: '/profitability',getParentRoute: () => AuthenticatedAdminAccountingRoute
          })
const AuthenticatedAdminAccountingPaymentsRoute = AuthenticatedAdminAccountingPaymentsRouteImport.update({
            id: '/payments',path: '/payments',getParentRoute: () => AuthenticatedAdminAccountingRoute
          })
const AuthenticatedAdminAccountingInvoicesRoute = AuthenticatedAdminAccountingInvoicesRouteImport.update({
            id: '/invoices',path: '/invoices',getParentRoute: () => AuthenticatedAdminAccountingRoute
          })
const AuthenticatedAdminAccountingExpensesRoute = AuthenticatedAdminAccountingExpensesRouteImport.update({
            id: '/expenses',path: '/expenses',getParentRoute: () => AuthenticatedAdminAccountingRoute
          })
const AuthenticatedAdminAccountingDepositsRoute = AuthenticatedAdminAccountingDepositsRouteImport.update({
            id: '/deposits',path: '/deposits',getParentRoute: () => AuthenticatedAdminAccountingRoute
          })
const AuthenticatedAdminProposalsIdPreviewRoute = AuthenticatedAdminProposalsIdPreviewRouteImport.update({
            id: '/preview',path: '/preview',getParentRoute: () => AuthenticatedAdminProposalsIdRoute
          })
const AuthenticatedAdminEstimatesIdProposalRoute = AuthenticatedAdminEstimatesIdProposalRouteImport.update({
            id: '/$id/proposal',path: '/$id/proposal',getParentRoute: () => AuthenticatedAdminEstimatesRoute
          })
const AuthenticatedAdminAccountingInvoicesIndexRoute = AuthenticatedAdminAccountingInvoicesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminAccountingInvoicesRoute
          })
const AuthenticatedAdminAccountingInvoicesNewRoute = AuthenticatedAdminAccountingInvoicesNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AuthenticatedAdminAccountingInvoicesRoute
          })
const AuthenticatedAdminAccountingInvoicesIdRoute = AuthenticatedAdminAccountingInvoicesIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AuthenticatedAdminAccountingInvoicesRoute
          })
const AuthenticatedAdminAccountingInvoicesIdPrintRoute = AuthenticatedAdminAccountingInvoicesIdPrintRouteImport.update({
            id: '/print',path: '/print',getParentRoute: () => AuthenticatedAdminAccountingInvoicesIdRoute
          })





const AuthenticatedAdminAccountingInvoicesIdRouteChildren = {
  AuthenticatedAdminAccountingInvoicesIdPrintRoute: AuthenticatedAdminAccountingInvoicesIdPrintRoute
}

const AuthenticatedAdminAccountingInvoicesIdRouteWithChildren = AuthenticatedAdminAccountingInvoicesIdRoute._addFileChildren(AuthenticatedAdminAccountingInvoicesIdRouteChildren)



const AuthenticatedAdminAccountingInvoicesRouteChildren = {
  AuthenticatedAdminAccountingInvoicesIdRoute: AuthenticatedAdminAccountingInvoicesIdRouteWithChildren,AuthenticatedAdminAccountingInvoicesNewRoute: AuthenticatedAdminAccountingInvoicesNewRoute,AuthenticatedAdminAccountingInvoicesIndexRoute: AuthenticatedAdminAccountingInvoicesIndexRoute
}

const AuthenticatedAdminAccountingInvoicesRouteWithChildren = AuthenticatedAdminAccountingInvoicesRoute._addFileChildren(AuthenticatedAdminAccountingInvoicesRouteChildren)



const AuthenticatedAdminAccountingRouteChildren = {
  AuthenticatedAdminAccountingDepositsRoute: AuthenticatedAdminAccountingDepositsRoute,AuthenticatedAdminAccountingExpensesRoute: AuthenticatedAdminAccountingExpensesRoute,AuthenticatedAdminAccountingInvoicesRoute: AuthenticatedAdminAccountingInvoicesRouteWithChildren,AuthenticatedAdminAccountingPaymentsRoute: AuthenticatedAdminAccountingPaymentsRoute,AuthenticatedAdminAccountingProfitabilityRoute: AuthenticatedAdminAccountingProfitabilityRoute,AuthenticatedAdminAccountingReceivablesRoute: AuthenticatedAdminAccountingReceivablesRoute,AuthenticatedAdminAccountingReportsRoute: AuthenticatedAdminAccountingReportsRoute,AuthenticatedAdminAccountingSettingsRoute: AuthenticatedAdminAccountingSettingsRoute
}

const AuthenticatedAdminAccountingRouteWithChildren = AuthenticatedAdminAccountingRoute._addFileChildren(AuthenticatedAdminAccountingRouteChildren)




const AuthenticatedAdminEstimatesRouteChildren = {
  AuthenticatedAdminEstimatesIdProposalRoute: AuthenticatedAdminEstimatesIdProposalRoute
}

const AuthenticatedAdminEstimatesRouteWithChildren = AuthenticatedAdminEstimatesRoute._addFileChildren(AuthenticatedAdminEstimatesRouteChildren)




const AuthenticatedAdminProposalsIdRouteChildren = {
  AuthenticatedAdminProposalsIdPreviewRoute: AuthenticatedAdminProposalsIdPreviewRoute
}

const AuthenticatedAdminProposalsIdRouteWithChildren = AuthenticatedAdminProposalsIdRoute._addFileChildren(AuthenticatedAdminProposalsIdRouteChildren)



const AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminAccountingRoute: AuthenticatedAdminAccountingRouteWithChildren,AuthenticatedAdminActivityRoute: AuthenticatedAdminActivityRoute,AuthenticatedAdminAiUsageRoute: AuthenticatedAdminAiUsageRoute,AuthenticatedAdminAnalyticsRoute: AuthenticatedAdminAnalyticsRoute,AuthenticatedAdminAuditRoute: AuthenticatedAdminAuditRoute,AuthenticatedAdminCalendarRoute: AuthenticatedAdminCalendarRoute,AuthenticatedAdminEstimatesRoute: AuthenticatedAdminEstimatesRouteWithChildren,AuthenticatedAdminFunnelsRoute: AuthenticatedAdminFunnelsRoute,AuthenticatedAdminHealthRoute: AuthenticatedAdminHealthRoute,AuthenticatedAdminHeatMapsRoute: AuthenticatedAdminHeatMapsRoute,AuthenticatedAdminHelpRoute: AuthenticatedAdminHelpRoute,AuthenticatedAdminLeadsRoute: AuthenticatedAdminLeadsRoute,AuthenticatedAdminMessagesRoute: AuthenticatedAdminMessagesRoute,AuthenticatedAdminNotificationSettingsRoute: AuthenticatedAdminNotificationSettingsRoute,AuthenticatedAdminOverviewRoute: AuthenticatedAdminOverviewRoute,AuthenticatedAdminPipelineRoute: AuthenticatedAdminPipelineRoute,AuthenticatedAdminPricingRoute: AuthenticatedAdminPricingRoute,AuthenticatedAdminReviewsRoute: AuthenticatedAdminReviewsRoute,AuthenticatedAdminSettingsRoute: AuthenticatedAdminSettingsRoute,AuthenticatedAdminTasksRoute: AuthenticatedAdminTasksRoute,AuthenticatedAdminUsersRoute: AuthenticatedAdminUsersRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,AuthenticatedAdminContactsIdRoute: AuthenticatedAdminContactsIdRoute,AuthenticatedAdminCustomersProjectIdRoute: AuthenticatedAdminCustomersProjectIdRoute,AuthenticatedAdminProposalsIdRoute: AuthenticatedAdminProposalsIdRouteWithChildren,AuthenticatedAdminContactsIndexRoute: AuthenticatedAdminContactsIndexRoute,AuthenticatedAdminCustomersIndexRoute: AuthenticatedAdminCustomersIndexRoute,AuthenticatedAdminProposalsIndexRoute: AuthenticatedAdminProposalsIndexRoute
}

const AuthenticatedAdminRouteWithChildren = AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)




const AuthenticatedPortalInvoicesRouteChildren = {
  AuthenticatedPortalInvoicesIdRoute: AuthenticatedPortalInvoicesIdRoute
}

const AuthenticatedPortalInvoicesRouteWithChildren = AuthenticatedPortalInvoicesRoute._addFileChildren(AuthenticatedPortalInvoicesRouteChildren)



const AuthenticatedPortalRouteChildren = {
  AuthenticatedPortalColorsRoute: AuthenticatedPortalColorsRoute,AuthenticatedPortalDashboardRoute: AuthenticatedPortalDashboardRoute,AuthenticatedPortalDocumentsRoute: AuthenticatedPortalDocumentsRoute,AuthenticatedPortalGalleryRoute: AuthenticatedPortalGalleryRoute,AuthenticatedPortalInvoicesRoute: AuthenticatedPortalInvoicesRouteWithChildren,AuthenticatedPortalMessagesRoute: AuthenticatedPortalMessagesRoute,AuthenticatedPortalNotificationSettingsRoute: AuthenticatedPortalNotificationSettingsRoute,AuthenticatedPortalNotificationsRoute: AuthenticatedPortalNotificationsRoute,AuthenticatedPortalPaymentsRoute: AuthenticatedPortalPaymentsRoute,AuthenticatedPortalProfileRoute: AuthenticatedPortalProfileRoute,AuthenticatedPortalProjectRoute: AuthenticatedPortalProjectRoute,AuthenticatedPortalProposalRoute: AuthenticatedPortalProposalRoute,AuthenticatedPortalScheduleRoute: AuthenticatedPortalScheduleRoute,AuthenticatedPortalWarrantyRoute: AuthenticatedPortalWarrantyRoute
}

const AuthenticatedPortalRouteWithChildren = AuthenticatedPortalRoute._addFileChildren(AuthenticatedPortalRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,AuthenticatedPortalRoute: AuthenticatedPortalRouteWithChildren,AuthenticatedSetupAdminRoute: AuthenticatedSetupAdminRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const ReviewTokenRouteChildren = {
  ReviewTokenThanksRoute: ReviewTokenThanksRoute
}

const ReviewTokenRouteWithChildren = ReviewTokenRoute._addFileChildren(ReviewTokenRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AboutRoute: AboutRoute,AuthRoute: AuthRoute,ColorsRoute: ColorsRoute,CommercialRoute: CommercialRoute,ContactRoute: ContactRoute,EstimateRoute: EstimateRoute,PortfolioRoute: PortfolioRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,ResidentialRoute: ResidentialRoute,ServiceAreasRoute: ServiceAreasRoute,ServicesRoute: ServicesRoute,StudioRoute: StudioRoute,TermsRoute: TermsRoute,UnsubscribeRoute: UnsubscribeRoute,GalleryProjectIdRoute: GalleryProjectIdRoute,ProposalTokenRoute: ProposalTokenRoute,ReviewTokenRoute: ReviewTokenRouteWithChildren,ShareTokenRoute: ShareTokenRoute,GalleryIndexRoute: GalleryIndexRoute,PortalIndexRoute: PortalIndexRoute,DotlovableOauthConsentRoute: DotlovableOauthConsentRoute,PortalClaimTokenRoute: PortalClaimTokenRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)